// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-item-label[data-v-0ae36b08]{padding:0 5px;border-radius:5px;font-size:12px}.give-away-icon[data-v-0ae36b08],.test-item-label[data-v-0ae36b08]{background:#ca4300;color:#fff;text-align:center;display:inline-block}.give-away-icon[data-v-0ae36b08]{width:23px;height:23px;border-radius:50%;font-size:14px;font-weight:700;line-height:23px;margin-left:10px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
